var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEditBlack = function SvgIconEditBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M12.613 3.173a2.5 2.5 0 0 1 3.536 0l1.178 1.179a2.5 2.5 0 0 1 0 3.535l-8.66 8.66a.83.83 0 0 1-.426.228l-4.42.884a.833.833 0 0 1-.98-.98l.884-4.42a.83.83 0 0 1 .228-.425zm2.357 1.179L16.15 5.53a.833.833 0 0 1 0 1.179L14.97 7.887 12.613 5.53l1.179-1.178a.833.833 0 0 1 1.178 0m-3.535 2.357L5.31 12.834l-.59 2.946 2.947-.59 6.125-6.124z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M12.613 3.173a2.5 2.5 0 0 1 3.536 0l1.178 1.179a2.5 2.5 0 0 1 0 3.535l-8.66 8.66a.83.83 0 0 1-.426.228l-4.42.884a.833.833 0 0 1-.98-.98l.884-4.42a.83.83 0 0 1 .228-.425zm2.357 1.179L16.15 5.53a.833.833 0 0 1 0 1.179L14.97 7.887 12.613 5.53l1.179-1.178a.833.833 0 0 1 1.178 0m-3.535 2.357L5.31 12.834l-.59 2.946 2.947-.59 6.125-6.124z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M12.613 3.173a2.5 2.5 0 0 1 3.536 0l1.178 1.179a2.5 2.5 0 0 1 0 3.535l-8.66 8.66a.83.83 0 0 1-.426.228l-4.42.884a.833.833 0 0 1-.98-.98l.884-4.42a.83.83 0 0 1 .228-.425zm2.357 1.179L16.15 5.53a.833.833 0 0 1 0 1.179L14.97 7.887 12.613 5.53l1.179-1.178a.833.833 0 0 1 1.178 0m-3.535 2.357L5.31 12.834l-.59 2.946 2.947-.59 6.125-6.124z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M12.613 3.173a2.5 2.5 0 0 1 3.536 0l1.178 1.179a2.5 2.5 0 0 1 0 3.535l-8.66 8.66a.83.83 0 0 1-.426.228l-4.42.884a.833.833 0 0 1-.98-.98l.884-4.42a.83.83 0 0 1 .228-.425zm2.357 1.179L16.15 5.53a.833.833 0 0 1 0 1.179L14.97 7.887 12.613 5.53l1.179-1.178a.833.833 0 0 1 1.178 0m-3.535 2.357L5.31 12.834l-.59 2.946 2.947-.59 6.125-6.124z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEditBlack;